const SUCCESS_MESSAGES = {
  CREDIT_MONITORING_UNSUBSCRIBE: 'You are now opted out of credit monitoring.',
  CREDIT_MONITORING_SUBSCRIBE: 'You are now opted in to credit monitoring.',
  EMAIL_UNSUBSCRIBE: 'You will no longer receive email notifications.',
  EMAIL_SUBSCRIBE: 'You will now receive email notifications.',
  PROMOS_UNSUBSCRIBE: 'You will no longer receive Promotion emails.',
  PROMOS_SUBSCRIBE: 'You will now receive Promotion emails.',
  OFFERS_UNSUBSCRIBE: 'You will no longer receive Offer emails.',
  OFFERS_SUBSCRIBE: 'You will now receive Offer emails.',
  EVENTS_UNSUBSCRIBE: 'You will no longer receive Event and Survey emails.',
  EVENTS_SUBSCRIBE: 'You will now receive Event and Survey emails.',
  ALERTS_UNSUBSCRIBE: 'You will no longer receive Carvana Inventory emails.',
  ALERTS_SUBSCRIBE: 'You will now receive Carvana Inventory emails.',
  PHONE_AND_TEXT_UNSUBSCRIBE: 'You will no longer receive phone notifications.',
  PHONE_AND_TEXT_SUBSCRIBE: 'You will now receive phone notifications.',
  PHONE_UNSUBSCRIBE: 'You will no longer receive phone calls.',
  PHONE_SUBSCRIBE: 'You will now receive phone calls.',
  SMS_UNSUBSCRIBE: 'You will no longer receive text messages.',
  SMS_SUBSCRIBE: 'You will now receive text messages.',
  PHONE_AND_SMS_UNSUBSCRIBE: 'You will no longer receive call or text notifications.',
  PHONE_AND_SMS_SUBSCRIBE: 'You will now receive call and text notifications.',
  UNSUBSCRIBE_FROM_ALL: 'You will no longer receive notifications.',
  SUBSCRIBE_TO_ALL: 'You are now subscribed to all notifications.'
};

export default SUCCESS_MESSAGES;
